import styled from "@emotion/styled";
export const EmailFormRoot = styled.div`
  display: flex;
  justify-content: space-between;
`;
